import { alpha } from '@mui/material';

export function isLinearGradient(color?: string | null) {
  return color && color.includes('linear-gradient');
}

export function formatColor(color: string, opacity?: number | null): string {
  if (isLinearGradient(color)) {
    return color;
  }

  if (color && opacity) {
    return alpha(color, opacity);
  }

  return color;
}
